import React from 'react'
import PropTypes from 'prop-types'
import { PriceChangeStatus } from 'components/station/components/competitor-pricing/context/constants'
import classNames from 'classnames/bind'
import styles from './ProgressBar.module.scss'

const cx = classNames.bind(styles)

const ProgressBar = ({ status }) => {
  if (status !== PriceChangeStatus.Send) {
    return null
  }

  return (
    <div className={cx('progress')}>
      <div className={cx('bar')} />
    </div>
  )
}

ProgressBar.propTypes = {
  status: PropTypes.string.isRequired,
}

export { ProgressBar }
